export default __webpack_public_path__ + "static/media/todolist.fd3e0776.png";